module.exports = __webpack_public_path__ + "static/media/04.4ae5c999.png";